import { Icon } from '@llt-frontend/react-material-icon';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

//

import { SUBJECT_NAMES, SUBJECT_SEARCH_PATTERNS } from '../../constants/subject-search-patterns';

//

function _ChessIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6h16v3H4V6zM3 19h18v3H3v-3z" fill="currentcolor" />
      <path
        d="M4 3h3v4H4zM17 3h3v4h-3zM10.5 3h3v4h-3zM6.75 9h10.5l-.853 3.932a2 2 0 00.043 1.014L18 19H6l1.56-5.054a2 2 0 00.043-1.014L6.75 9z"
        fill="currentcolor"
      />
    </svg>
  );
}

function _DinoIcon() {
  return (
    <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 9.778C7 11.005 6.105 12 5 12s-2-.995-2-2.222C3 8.55 3.8 4.888 5 4c1.2.889 2 4.55 2 5.778zM14.5 8.5a2.5 2.5 0 01-5 0c0-1.38 1-5.5 2.5-6.5 1.5 1 2.5 5.12 2.5 6.5zM21 9.778C21 11.005 20.38 12 19 12s-2-.995-2-2.222c0-1.228.5-4.89 2-5.778 1.5.889 2 4.55 2 5.778z"
        fill="currentcolor"
      />
      <path
        d="M6 15c.825.867 2.797 5.892 3.631 6.76.437.458.634.926 1.298 1.13.104.034.209.059.313.076.237.034.493.034.74.034.246 0 .502 0 .749-.043.104-.017.209-.042.313-.076.664-.204.884-.663 1.33-1.122.825-.867 3.291-5.892 4.126-6.759 2-2 3-3 3-6 0-2-5-2-5 .4 0 2.6-1.026 3.45-1.5 2.6-.475-.425.852-6-1.5-6h-3C8.148 6 9.474 11.575 9 12c-.474.85-1.5 0-1.5-2.5s-5-2.5-5-.5c0 3 2.258 4.887 3.5 6z"
        fill="currentcolor"
      />
    </svg>
  );
}

function _ELAIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21,5a11.8,11.8,0,0,0-3.5-.5A9.3,9.3,0,0,0,12,6,9.3,9.3,0,0,0,6.5,4.5,9.3,9.3,0,0,0,1,6V20.65a.54.54,0,0,0,.5.5c.1,0,.15,0,.25,0A12.21,12.21,0,0,1,6.5,20,9.3,9.3,0,0,1,12,21.5,12,12,0,0,1,17.5,20a10.18,10.18,0,0,1,4.75,1.05.45.45,0,0,0,.25.05.54.54,0,0,0,.5-.5V6A6.82,6.82,0,0,0,21,5Zm0,13.5a11.62,11.62,0,0,0-3.5-.5A12,12,0,0,0,12,19.5V8a12,12,0,0,1,5.5-1.5A11.62,11.62,0,0,1,21,7Z"
        fill="currentcolor"
      />
      <path
        d="M17.5,10.5a11.69,11.69,0,0,1,2.5.26V9.24A13.5,13.5,0,0,0,17.5,9a11.51,11.51,0,0,0-4.5.83v1.66A9.28,9.28,0,0,1,17.5,10.5Z"
        fill="currentcolor"
      />
      <path
        d="M13,12.49v1.66a9.28,9.28,0,0,1,4.5-1,11.69,11.69,0,0,1,2.5.26V11.9a13.5,13.5,0,0,0-2.5-.24A11.69,11.69,0,0,0,13,12.49Z"
        fill="currentcolor"
      />
      <path
        d="M17.5,14.33a11.51,11.51,0,0,0-4.5.83v1.66a9.28,9.28,0,0,1,4.5-1,11.69,11.69,0,0,1,2.5.26V14.57A12.7,12.7,0,0,0,17.5,14.33Z"
        fill="currentcolor"
      />
    </svg>
  );
}

//

function _MathIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.78,2H4.22A2.23,2.23,0,0,0,2,4.22V19.78A2.23,2.23,0,0,0,4.22,22H19.78A2.23,2.23,0,0,0,22,19.78V4.22A2.23,2.23,0,0,0,19.78,2ZM13.14,6.51l1.18-1.18L15.89,6.9l1.57-1.57,1.17,1.18L17.07,8.08l1.56,1.56-1.17,1.18L15.89,9.27l-1.57,1.56L13.14,9.66l1.57-1.57Zm-7.53.73h5.56V8.91H5.61Zm5.83,9.2H9.22v2.23H7.56V16.44H5.33V14.78H7.56V12.56H9.22v2.22h2.22Zm7.23,1.39H13.11V16.17h5.56Zm0-2.77H13.11V13.39h5.56Z"
        fill="currentcolor"
      />
    </svg>
  );
}

//

function _ScienceIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.67,19.46,16,9.73V3h1a1,1,0,0,0,0-2H7A1,1,0,0,0,7,3H8V9.73L2.33,19.46a2.35,2.35,0,0,0,2,3.54H19.64a2.35,2.35,0,0,0,2-3.54ZM15,15a2,2,0,0,0-4,0H7.24L10,10.27V7.91a1.64,1.64,0,0,0,.5.09,1.5,1.5,0,0,0,0-3,1.64,1.64,0,0,0-.5.09V3h4v7.27L16.76,15Zm-3-5a1,1,0,1,0,1,1A1,1,0,0,0,12,10Z"
        fill="currentcolor"
      />
    </svg>
  );
}

//

function _WritingIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.449 16.958a.467.467 0 00.052.003l-.001.001a.5.5 0 00.496-.444c.001-.01.124-1.09.491-2.282.463-1.504 1.09-2.49 1.815-2.851a.36.36 0 00.054-.031c.546-.363 1.135-.525 1.909-.525.425 0 .87.05 1.3.097l.009.001h.008c.447.05.908.102 1.367.102.792 0 1.43-.154 2.009-.484a9.025 9.025 0 002.983-2.72.497.497 0 00-.405-.784h-.101c-.288 0-.875.005-1.557.039l.093-.032.004-.002c1.064-.368 2.163-.749 2.773-1.357C20.123 5.315 21 4.44 21 3.499A.5.5 0 0020.5 3c-1.032 0-4.366.655-7.556 2.602C11.1 6.727 9.589 8.106 8.451 9.7c-1.387 1.943-2.21 4.203-2.449 6.716a.5.5 0 00.447.542zm7.018-10.506c2.487-1.517 5.033-2.188 6.338-2.387h.001c-.231.388-.605.76-.763.918-.448.448-1.437.79-2.393 1.122l-.005.001c-1.207.418-2.346.813-2.823 1.526a.498.498 0 00.545.758c.848-.225 2.197-.306 3.125-.335a7.921 7.921 0 01-2.028 1.624c-.422.24-.902.352-1.513.352-.4 0-.81-.045-1.243-.093l-.022-.002h-.006c-.458-.052-.932-.104-1.414-.104-.745 0-1.38.13-1.956.404 1.24-1.721 2.781-2.944 4.157-3.784z"
        fill="currentcolor"
      />
      <path
        d="M9 17.46c0 .782.562 1.415.568 1.421h.001a1.615 1.615 0 010 2.144c-.087.095-.91.923-3.068.923s-2.981-.828-3.068-.923a1.615 1.615 0 010-2.144l.001-.001c.027-.031.567-.654.567-1.42 0-.226.077-.562.441-.876a.5.5 0 01.654.754c-.079.068-.095.114-.095.122 0 .017.053.132.309.26.306.15.739.239 1.191.239.452 0 .886-.087 1.191-.24.255-.127.309-.242.309-.26 0-.01-.025-.072-.139-.156a.498.498 0 01-.105-.697.5.5 0 01.699-.104c.351.259.544.599.544.958zm-2.5 3.49c1.704 0 2.325-.593 2.331-.6v.002a.616.616 0 000-.797 3.555 3.555 0 01-.604-.99 2.496 2.496 0 01-.089.047c-.446.222-1.027.345-1.638.345s-1.192-.123-1.638-.345c-.031-.015-.06-.031-.089-.047a3.555 3.555 0 01-.604.99.616.616 0 00-.005.79c.043.04.68.605 2.336.605z"
        fill="currentcolor"
      />
    </svg>
  );
}

//

function SubjectIcon({ className, subjectName, ...forwardedProps }) {
  //
  // Methods

  function getIconName() {
    for (const { name, pattern } of SUBJECT_SEARCH_PATTERNS) {
      if (pattern?.test(subjectName)) {
        return name;
      }
    }
  }

  /* eslint-disable complexity */
  function getIcon() {
    switch (getIconName()) {
      case SUBJECT_NAMES.ancientAdventures:
        return 'account_balance';
      case SUBJECT_NAMES.beginningCoders:
      case SUBJECT_NAMES.roblox:
        return 'code';
      case SUBJECT_NAMES.brainteasers:
        return 'psychology';
      case SUBJECT_NAMES.camp:
        return 'festival';
      case SUBJECT_NAMES.chessMasters:
        return <_ChessIcon />;
      case SUBJECT_NAMES.chineseLanguageAndTravel:
      case SUBJECT_NAMES.spanishLanguageAndTravel:
        return 'travel_explore';
      case SUBJECT_NAMES.club:
      case SUBJECT_NAMES.cosmicAdventures:
        return 'auto_awesome';
      case SUBJECT_NAMES.creativeWriting:
        return 'history_edu';
      case SUBJECT_NAMES.curiousWorld:
        return 'precision_manufacturing';
      case SUBJECT_NAMES.digitalPhotography:
        return 'photo_camera';
      case SUBJECT_NAMES.dinoDiscovery:
        return <_DinoIcon />;
      case SUBJECT_NAMES.drama:
        return 'theater_comedy';
      case SUBJECT_NAMES.juniorGeologists:
        return 'terrain';
      case SUBJECT_NAMES.englishLanguageArts:
        return <_ELAIcon />;
      case SUBJECT_NAMES.math:
        return <_MathIcon />;
      case SUBJECT_NAMES.mathletics:
        return 'functions';
      case SUBJECT_NAMES.magic:
        return 'cruelty_free';
      case SUBJECT_NAMES.moneyMatters:
        return 'savings';
      case SUBJECT_NAMES.science:
        return <_ScienceIcon />;
      case SUBJECT_NAMES.scienceFiction:
        return 'rocket_launch';
      case SUBJECT_NAMES.sketchmasters:
        return 'gesture';
      case SUBJECT_NAMES.sportsAnalytics:
        return 'insights';
      case SUBJECT_NAMES.teachRock:
        return 'music_note';
      case SUBJECT_NAMES.theater:
        return 'theater_comedy';
      case SUBJECT_NAMES.weatherWonders:
        return 'storm';
      case SUBJECT_NAMES.wildlifeCreatures:
        return 'pets';
      case SUBJECT_NAMES.writing:
        return <_WritingIcon />;
      case SUBJECT_NAMES.youngAnimators:
        return 'animation';

      default:
        return (
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.53,5H17V2H7.53a1.5,1.5,0,1,0,0,3Zm0,1A2.53,2.53,0,0,1,5.05,4H5V19.14A2.86,2.86,0,0,0,7.86,22H19V6ZM15,13H10V9h5Z"
              fill="currentcolor"
            />
          </svg>
        );
    }
  }
  /* eslint-enable complexity */

  //
  // Render

  return (
    <Icon {...forwardedProps} className={classNames('subject-icon', className)}>
      {getIcon(subjectName)}
    </Icon>
  );
}

SubjectIcon.propTypes = {
  subjectName: PropTypes.string.isRequired,
};

// Exports
// -------

export default SubjectIcon;
